require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./study-icaew-identity-integration-case-study.json") })
        }
      }, "path---study-icaew-identity-integration-case-study");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---study-icaew-identity-integration-case-study!./.cache/json/study-icaew-identity-integration-case-study.json
// module id = 927
// module chunks = 231608221292675